module.exports = __webpack_public_path__ + "media/LandingPageAssets/twitterIcon-0efbb36f.svg";